/**
 * @file コンポーネント：フル動画ページスレッドボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledButton, StyledButtonIcon, StyledButtonText } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <StyledButton onClick={(e) => props.fnOnClickThread(e)}>
            <StyledButtonIcon>
                <i className="fas fa-comments"></i>
            </StyledButtonIcon>
            <StyledButtonText>
                {localized["Label.ThreadComments"]}
            </StyledButtonText>
        </StyledButton>
    );
};
